import get from 'lodash/get'
import set from 'lodash/set'
import request from '../../../request'
import { createAuthorization } from '../../../auth'

export async function getNotificationTypes ({ auth, server }) {
  const res = await request
    .get(`${server}/notifications/types`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
    .set('content-type', 'application/json')
  return get(res, 'body', {})
}

export async function createNotification ({ auth, server, attributes }) {
  const res = await request
    .post(`${server}/notifications`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
    .send(attributes)
  return get(res, 'body', {})
}

export async function deleteNotification ({ auth, server, id }) {
  const res = await request
    .delete(`${server}/notifications/${id}`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return get(res, 'body', {})
}

export async function updateNotification ({ auth, server, attributes }) {
  const res = await request
    .put(`${server}/notifications`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
    .send(attributes)
  return get(res, 'body', {})
}

export async function getNotification ({ auth, server, id }) {
  const res = await request
    .get(`${server}/notifications/${id}`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
    .set('content-type', 'application/json')
  return get(res, 'body', {})
}

export async function getNotifications ({
  auth, server, type, p, pp,
}) {
  const query = {
    p: p || 1,
    pp: pp || 10,
  }

  if (type) {
    set(query, 'type', type)
  }

  const res = await request
    .get(`${server}/notifications`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
    .set('content-type', 'application/json')
    .query(query)
  return get(res, 'body', {})
}
